import React from 'react';
import styles from './styles.module.scss';
import { HelpTooltip, Table, Tooltip } from 'tt-ui-lib/core';
import Pagination from '@mui/material/Pagination';
import FCEMLogo from '../../../../../modules/tt-tokenized-assets/components/CertificatePage/Components/FcemLogo';

const OffsetsTabContent = ({
  className,
  style,
  data,
  onRowClick,
  paginatorInfo,
  customColumns = null,
  isLoading = false,
  description = null,
  changePage,
}) => {
  const getterHash = (val) =>
    val && val.length > 10
      ? `${val.substring(0, 5)}...${val.substring(val.length - 3)}`
      : val || '-';

  const columns = [
    {
      key: 'id',
      dataIndex: 'id',
      title: 'ID',
      align: 'left',
      width: 50,
      render: (value, row) => (
        <div className={styles.idCell}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span>{getterHash(value) || '-'}</span>
          </div>

          {row.deposit && row.deposit !== '0' && (
            <Tooltip title="With FCEM deposit" placement="top" trigger="hover">
              <span>
                <FCEMLogo />
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      key: 'date',
      dataIndex: 'date',
      title: 'Date',
      align: 'left',
      width: 50,
      render: (val) => <span>{val || '-'}</span>,
    },
    {
      key: 'quantity',
      dataIndex: 'quantity',
      title: 'Offset Balance',
      align: 'left',
      width: 50,
      render: (val) => <span>{val || '-'}</span>,
    },
  ];
  return (
    <div className={`${styles.container} ${className} HoldersTable`} style={{ ...style }}>
      <div className={styles.row1}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span className={`${styles.h1} ${styles.header}`} style={{ marginBottom: 0 }}>
            Offsets
          </span>
          <HelpTooltip tooltipText="All your tokenized carbon offsets certificates you can find in this section. Clicking on the tokenize carbon offse ID, you get access to detailed information and more options." />
        </div>
      </div>

      {description && <div className={styles.desc}>{description}</div>}

      <div style={{ width: '100%', overflowX: 'auto' }}>
        <Table
          loading={isLoading}
          columns={customColumns || columns}
          data={data}
          // onRow={(row) => ({
          //   onClick: () => onRowClick(row),
          // })}
          scroll={{ x: 870, y: '500px' }}
          pagination={false}
        />
        {paginatorInfo.lastPage > 1 && !isLoading && (
          <div className={styles.paginationBlock}>
            <Pagination
              count={paginatorInfo.lastPage}
              page={paginatorInfo.currentPage || 1}
              onChange={(event, page) => changePage(page)}
              size="medium"
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default OffsetsTabContent;
